import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../../../auth/auth.service';
import { resolveEventFormOrganizationId } from './event-form-org.util';

export interface EventCategoryChoice {
  value: string;
  text: string;
  color: string;
}

/**
 * Dropdown choices for event category from org event_category_colors.
 */
export function event_category_choices(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'event_category_choices',
    description: 'Category choices for add/edit event form',
    execute: (params?: LoadDataParams): Observable<{ items: EventCategoryChoice[]; totalCount: number }> => {
      const auth = service.injector.get(AuthService);
      const orgId = resolveEventFormOrganizationId(params, auth);
      if (orgId == null) {
        return of({ items: [], totalCount: 0 });
      }
      const obs = service.executeDataSource('org_settings', { organizationId: orgId });
      if (!obs) {
        return of({ items: [], totalCount: 0 });
      }
      return obs.pipe(
        map((res: { data?: Record<string, unknown> }) => {
          const raw = res?.data?.['event_category_colors'];
          const items = normalizeCategoryChoices(raw);
          return { items, totalCount: items.length };
        }),
        catchError(() => of({ items: [], totalCount: 0 }))
      );
    },
  };
}

function normalizeCategoryChoices(value: unknown): EventCategoryChoice[] {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return [];
  }
  const entries = Object.entries(value as Record<string, unknown>);
  const choices: EventCategoryChoice[] = [];
  for (const [category, color] of entries) {
    const name = (category || '').trim();
    if (!name) {
      continue;
    }
    const colorStr =
      typeof color === 'string' && color.trim() !== '' ? color.trim() : '#1976d2';
    choices.push({ value: name, text: name, color: colorStr });
  }
  choices.sort((a, b) => a.text.localeCompare(b.text, 'da-DK'));
  return choices;
}
